import { rando } from '../../lib/rando-sidecar'
import { createId } from '../../main/common'
import { common } from '../../main/common-sidecar'
import { voyageMessageCrewCarry } from './multi/voyageMessageCrewCarry-sidecar'
import { EVoyageCrewCreateMethod } from './multi/voyageMessageCrewCreate'
import { voyageMessageCrewCreate } from './multi/voyageMessageCrewCreate-sidecar'
import { EEffectCommand } from './multi/voyageMessageEffectCommand'
import { voyageMessageEffectCommand } from './multi/voyageMessageEffectCommand-sidecar'
import {
  EVoyageEnemyShipCommand,
  EVoyageEnemyShipType,
} from './multi/voyageMessageEnemyShipCommand'
import { voyageMessageEnemyShipCommand } from './multi/voyageMessageEnemyShipCommand-sidecar'
import { EVoyageCarryableType } from './voyageCarryableData'
import { EVoyageCrewType } from './voyageCrew'
import { voyageGameMode_game_hyperspace } from './voyageGameMode_game_hyperspace-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageGameStatus_enemyShips } from './voyageGameStatus_enemyShips-sidecar'
import { voyageTestParams } from './voyageTestParams-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

// let _directorTimer = 0
// let _directorTime = 25
// let _adaptiveDifficulty = 0.97 // 0.965
// let _superTestMode = false && voyageTestParams.isDevMode
let _events = ['boarded', 'fire', 'ship', 'nothing', 'hull-breach', 'bomb']
// if (_superTestMode) {
//   _directorTime = 10
//   _directorTimer = _directorTime
//   // _events = ['fire', 'hull-breach']
//   _events = ['boarded']
// }

export function signalAction() {
  // TODO: signal mission?
  //_directorTimer = _directorTime
}

export function* generator_director(): Generator<number, number, number> {
  voyageGameStatus.get().isGameStarted = true
  voyageGameStatus.get().isGameEnded = false

  let hyper = voyageGameMode_game_hyperspace.generator_hyperspace()

  while (true) {
    // let ds = common.getUpdateDeltaScaled()

    hyper.next()
    if (voyageGameMode_game_hyperspace.getIsInHyperspace()) {
      yield 0
      continue
    }

    let status = voyageGameStatus.get()
    if (status.isGameEnded) {
      //} //else if (status.isAtStarbase) {
      // At starbase // TODO: special mission?
    } else {
      // On a mission

      let mission = status.currentMission
      let r = mission.genMission.next()

      if (r.done) {
        // yield 0
      } else {
        if (r.value) {
          yield r.value
        }
      }
    }

    yield 0
  }
}
